// Helpers globais para evitar requisições duplicadas para endpoints ShopifyData
(function() {
  const filteredDataCache = {};
  const metaobjectsCache = {};
  const productsCache = {};
  const metafieldsCache = {};

  window.fetchFilteredDataOnce = async function(termId, campusId) {
    const key = `${campusId}|${termId}`;

    if (filteredDataCache[key]) {
      return filteredDataCache[key];
    }

    const proxyPath = '/apps/shopifyData/getFilteredData';
    const url = `${proxyPath}?campus_entity_id=${campusId}&term_id=${termId}`;

    const promise = (async () => {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (!result.success) {
        throw new Error(result.error || 'Failed to fetch metaobjects');
      }

      return result.data;
    })();

    filteredDataCache[key] = promise;
    return promise;
  };

  window.fetchMetaobjectsOnce = async function(metaobjectType, queryRaw) {
    const query = queryRaw ?? '';
    const key = `${metaobjectType}|${query}`;

    if (metaobjectsCache[key]) {
      return metaobjectsCache[key];
    }

    const proxyPath = '/apps/shopifyData/metaobjects';
    const url = `${proxyPath}?type=${encodeURIComponent(metaobjectType)}&query=${encodeURIComponent(query)}`;

    const promise = (async () => {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (!result.success) {
        throw new Error(result.error || 'Failed to fetch metaobjects');
      }

      const activeMetaobjects = Array.isArray(result.data)
        ? result.data.filter(item => item.status === 'ACTIVE')
        : result.data;

      return activeMetaobjects;
    })();

    metaobjectsCache[key] = promise;
    return promise;
  };

  window.fetchProductsOnce = async function(queryRaw) {
    const query = queryRaw ?? '';
    const key = query;

    if (productsCache[key]) {
      return productsCache[key];
    }

    const proxyPath = '/apps/shopifyData/products';
    const url = `${proxyPath}?query=${encodeURIComponent(query)}`;

    const promise = (async () => {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (!result.success) {
        throw new Error(result.error || 'Failed to fetch products');
      }

      return result.products;
    })();

    productsCache[key] = promise;
    return promise;
  };

  window.fetchMetafieldsOnce = async function(variantId) {
    const key = String(variantId);

    if (metafieldsCache[key]) {
      return metafieldsCache[key];
    }

    const proxyPath = '/apps/shopifyData/getMetafields';
    const url = `${proxyPath}?query=gid://shopify/ProductVariant/${encodeURIComponent(variantId)}`;

    const promise = (async () => {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (!result.success) {
        throw new Error(result.error || 'Failed to fetch Metafields');
      }

      return result.data;
    })();

    metafieldsCache[key] = promise;
    return promise;
  };
})();

/** @param {HTMLOptionElement | undefined} opt */
function cmrpOptionLabelForMatch(opt) {
  if (!opt) return '';
  if (
    typeof window !== 'undefined' &&
    typeof window.cmrpOptionFullLabel === 'function'
  ) {
    return window.cmrpOptionFullLabel(opt);
  }
  return String(opt.text ?? '').trim();
}

/**
 * Course-builder DDCS `<select>` ids use `cmrpId(base, 'cb')` (e.g. `division-cb`) when dual-form.
 */
function cmrpCbCourseLineSelectId(base) {
  if (typeof window !== 'undefined' && typeof window.cmrpId === 'function') {
    return window.cmrpId(base, 'cb');
  }
  return base;
}

function cmrpUrlRestoreDebug(tag, detail = {}) {
  if (typeof window !== 'undefined' && typeof window.cmrpDdcsDebug === 'function') {
    window.cmrpDdcsDebug('urlRestore.' + tag, detail);
  }
}

/** URLSearchParams + our own encoding can leave values that break `decodeURIComponent`. */
function cmrpSafeDecodeURIComponent(value) {
  if (value == null) return '';
  const s = String(value);
  if (!s) return '';
  try {
    return decodeURIComponent(s.replace(/\+/g, ' '));
  } catch {
    return s;
  }
}

function cmrpNormalizeFlowForStorage(rawFlow) {
  const flow = String(rawFlow || '').trim().toLowerCase();
  if (flow === 'student-id' || flow === 'course-builder' || flow === 'sso') return flow;
  return '';
}

function cmrpPersistFlowFromUrlState(flow) {
  const normalized = cmrpNormalizeFlowForStorage(flow);
  if (!normalized) return;
  if (typeof window.cmrpPersistFlow === 'function') {
    window.cmrpPersistFlow(normalized);
    return;
  }
  try {
    sessionStorage.setItem('cmrp_flow', normalized);
  } catch (e) {
    /* ignore */
  }
}

/** FM-2391: decode HTML entities in DDCS labels (optional: window.decodeCmrpHtmlEntities from sidebar). */
function decodeCmrpLabel(text) {
  if (typeof window !== 'undefined' && typeof window.decodeCmrpHtmlEntities === 'function') {
    return window.decodeCmrpHtmlEntities(text);
  }
  if (text == null || text === '') return text ?? '';
  const str = String(text);
  if (!str.includes('&')) return str;
  const ta = document.createElement('textarea');
  ta.innerHTML = str;
  return ta.value;
}

class URLStateManager {
  /** @param {string} [search] */
  static hasDeepLinkCourseParamsInSearch(search) {
    const p = new URLSearchParams(search ?? '');
    return Boolean(
      p.get('sectionDisplayName') ||
        p.get('courseDisplayName') ||
        p.get('courseRefId')
    );
  }

  constructor(config = {}) {
    // @ts-ignore
    this.selectedFilters = config.selectedFilters || [];
    // @ts-ignore
    this.ddcsSection = config.ddcsSection || [];
    // @ts-ignore
    this.ddcsCampusEntity = config.ddcsCampusEntity || [];
    // @ts-ignore
    this.ddcsTerm = config.ddcsTerm || [];
    // @ts-ignore
    this.ddcsCampusDepartment = config.ddcsCampusDepartment || [];
    // @ts-ignore
    this.ddcsCourse = config.ddcsCourse || [];
    // @ts-ignore
    this.addLabelCallback = config.addLabelCallback || (() => {});
    // @ts-ignore
    this.refreshProductsCallback = config.refreshProductsCallback || (() => {});

    this.URL_PARAMS = {
      SHOP_BY: 'shopBy',
      TERM_ID: 'termId',
      DIVISION_DISPLAY_NAME: 'divisionDisplayName',
      DEPARTMENT_DISPLAY_NAME: 'departmentDisplayName',
      COURSE_DISPLAY_NAME: 'courseDisplayName',
      COURSE_REF_ID: 'courseRefId',
      SECTION_DISPLAY_NAME: 'sectionDisplayName',
    };

    this.urlParamsToRestore = null;
    /** Deep-link arrays captured once on init; sidebar may call `setURLSearchParams` before restore. */
    this._initialUrlRestoreSnapshot = null;
    /** While true, skip stripping CMRP params from the URL when filters are still empty (URL restore / sidebar init). */
    this._deferEmptyFilterUrlStrip = false;
    /** True while attemptURLRestoration / restoreFormStateFromURL is in flight. */
    this._isUrlRestoreInProgress = false;
    /** shopBy from the landing URL (e.g. discoverview) preserved across URL sync. */
    this._preservedShopByFromUrl = '';

    // Bind methods to preserve context
    this.parseURLParameters = this.parseURLParameters.bind(this);
    this.setURLSearchParams = this.setURLSearchParams.bind(this);
    this.restoreFormStateFromURL = this.restoreFormStateFromURL.bind(this);
    this.buildFiltersFromURLParams = this.buildFiltersFromURLParams.bind(this);
    this.findMatchingEntities = this.findMatchingEntities.bind(this);
    this.createFilterObject = this.createFilterObject.bind(this);
    this.restoreDropdownsAndUI = this.restoreDropdownsAndUI.bind(this);
    this.setCampusDropdown = this.setCampusDropdown.bind(this);
    this.setTermDropdown = this.setTermDropdown.bind(this);
    this.populateTermsForCampus = this.populateTermsForCampus.bind(this);
    this.restoreAllFormFieldsFromURL =
      this.restoreAllFormFieldsFromURL.bind(this);
    this.restoreFieldsCascade = this.restoreFieldsCascade.bind(this);
    this.continueWithDepartment = this.continueWithDepartment.bind(this);
    this.continueWithCourse = this.continueWithCourse.bind(this);
    this.continueWithSection = this.continueWithSection.bind(this);
    this.finishRestore = this.finishRestore.bind(this);
    this.triggerDepartmentCascadeForRestore =
      this.triggerDepartmentCascadeForRestore.bind(this);
    this.attemptURLRestoration = this.attemptURLRestoration.bind(this);
    this.clearExistingFilters = this.clearExistingFilters.bind(this);
    this.cmrpUrlRestoreCampusTermSelect =
      this.cmrpUrlRestoreCampusTermSelect.bind(this);
    /** @type {boolean} */
    this._cmrpUrlRestoreTargetStudentIdForm = false;
  }

  isUrlRestorePending() {
    return Boolean(this._deferEmptyFilterUrlStrip || this._isUrlRestoreInProgress);
  }

  /**
   * Campus/term `<select>` used while restoring from URL: student-id row when dual CMRP docks
   * results under the student-id anchor; otherwise course-builder / legacy ids.
   * @param {'campus'|'term'} inner
   * @returns {HTMLElement | null}
   */
  cmrpUrlRestoreCampusTermSelect(inner) {
    if (
      this._cmrpUrlRestoreTargetStudentIdForm &&
      typeof window.cmrpId === 'function'
    ) {
      const panel = document.getElementById('filters-section');
      const suf = (panel?.dataset?.cmrpSuffixStudentId || 'sid').trim();
      if (!suf) return null;
      const rootId = `campus-term-dropdowns-${suf}`;
      const fieldId = window.cmrpId(inner, 'sid');
      return document.querySelector(`#${rootId} #${fieldId}`);
    }
    if (typeof window.cmrpCourseBuilderCampusTermEl === 'function') {
      return window.cmrpCourseBuilderCampusTermEl(inner);
    }
    if (typeof window.cmrpQueryDesktopCampusTerm === 'function') {
      return window.cmrpQueryDesktopCampusTerm(inner);
    }
    return document.querySelector(`#campus-term-dropdowns #${inner}`);
  }

  /**
   * @param {boolean} [persistRestoreSnapshot=false] - When true (initial page load only), store parsed
   *   course-line params on `urlParamsToRestore` for one-time form restoration. When false, read the
   *   current URL without updating that snapshot so later URL updates do not re-hydrate the builder row.
   */
  parseURLParameters(persistRestoreSnapshot = false) {
    const stripped = new URLSearchParams(window.location.search);
    const landingShopBy = stripped.get(this.URL_PARAMS.SHOP_BY);
    if (landingShopBy) {
      this._preservedShopByFromUrl = landingShopBy;
    }
    if (stripped.has('student_id')) {
      stripped.delete('student_id');
      const qs = stripped.toString();
      window.history.replaceState(
        {},
        '',
        qs ? `${window.location.pathname}?${qs}` : window.location.pathname
      );
    }
    const urlParams = new URLSearchParams(window.location.search);
    const rawTermIdFromUrl = urlParams.get(this.URL_PARAMS.TERM_ID)?.trim() ?? null;

    const params = {
      // @ts-ignore
      shopBy: urlParams.get(this.URL_PARAMS.SHOP_BY),
      // @ts-ignore
      termId: rawTermIdFromUrl?.toLowerCase().replace(/\s+/g, '') ?? null,
      // @ts-ignore
      rawTermId: rawTermIdFromUrl,
      // @ts-ignore
      divisionDisplayName: urlParams.get(this.URL_PARAMS.DIVISION_DISPLAY_NAME),
      // @ts-ignore
      departmentDisplayName: urlParams.get(
        this.URL_PARAMS.DEPARTMENT_DISPLAY_NAME
      ),
      // @ts-ignore
      courseDisplayName: urlParams.get(this.URL_PARAMS.COURSE_DISPLAY_NAME),
      // @ts-ignore
      courseRefId: urlParams.get(this.URL_PARAMS.COURSE_REF_ID),
      // @ts-ignore
      sectionDisplayName: urlParams.get(this.URL_PARAMS.SECTION_DISPLAY_NAME),
      // @ts-ignore
      
    };

    const parsed = {
      rawTermId: params.rawTermId,
      termsIds: params.termId && params.sectionDisplayName     ? Array(params.sectionDisplayName.split('|').length).fill(params.termId)     : [],
      divisions: params.divisionDisplayName
        ? params.divisionDisplayName.split('|')
        : [],
      departments: params.departmentDisplayName
        ? params.departmentDisplayName.split('|')
        : [],
      courses: params.courseDisplayName
        ? params.courseDisplayName.split('|')
        : [],
      courseRefIds: params.courseRefId
        ? params.courseRefId.split('|')
        : [],
      sections: params.sectionDisplayName
        ? params.sectionDisplayName.split('|')
        : [],
    };
    const needsTermIdsForCourseRef =
      parsed.termsIds.length === 0 &&
      Boolean(params.termId) &&
      parsed.courseRefIds.length > 0;
    if (needsTermIdsForCourseRef) {
      parsed.termsIds = Array(parsed.courseRefIds.length).fill(params.termId);
    }
    //console.log("urlParamsToRestore ==> ", parsed);
    if (persistRestoreSnapshot) {
      this.urlParamsToRestore = parsed;
    }
    return parsed;
  }

  setURLSearchParams() {
    const studentIdField = document.getElementById(
      typeof window.cmrpId === 'function'
        ? window.cmrpId('student-id', 'sid')
        : 'student-id',
    );
    const mobileStudentIdInput = document.getElementById(
      'mobile-student-id-input'
    );
    // @ts-ignore
    const typedStudentId = (
      studentIdField?.value ||
      mobileStudentIdInput?.value ||
      ''
    ).trim();

    const dualCmrp =
      document.getElementById('filters-section')?.dataset?.cmrpStudentIdActive ===
      'true';
    let forStudentIdFlow;
    if (dualCmrp && this.selectedFilters.length > 0) {
      forStudentIdFlow = this.selectedFilters.every(
        f => f && f.fromStudentId === true,
      );
    } else {
      forStudentIdFlow = Boolean(typedStudentId);
    }

    const paramStrings = this.buildParameterStrings();
    console.info('[CMRP url] setURLSearchParams', {
      filterCount: this.selectedFilters.length,
      hasStudentId: forStudentIdFlow,
      paramPreview: {
        departments: paramStrings.selectedDepartment?.slice(0, 80),
        courses: paramStrings.selectedcourse?.slice(0, 80),
        sections: paramStrings.selectedsection?.slice(0, 80),
      },
    });
    // Always sync the address bar: when there are no courses, strip shop/course params
    // (previously we returned early and left stale deep links like departmentDisplayName=…).
    this.updateURLWithParameters(paramStrings, forStudentIdFlow);
  }

  clearURL() {
    const params = new URLSearchParams(window.location.search);
    
    Object.values(this.URL_PARAMS).forEach(param => params.delete(param));
    params.delete('cmrp_flow');

    

    const newUrl = params.toString()
      ? `${window.location.pathname}?${params}`
      : window.location.pathname;

    window.history.replaceState({}, '', newUrl);
  }

  /**
   * Campus DDCS flags for the campus on the current filter set (URL shaping only).
   * @returns {{ is_department_used_flag: boolean, is_division_used_flag: boolean } | null}
   */
  _campusFlagsForSelectedCampus() {
    const campusName = this.selectedFilters[0]?.selectedCampus;
    if (!campusName || !window.courseData?.ddcs_campus_entity) {
      return null;
    }
    const normalize = v =>
      String(v ?? '')
        .toLowerCase()
        .replace(/\s+/g, '');
    const hit = window.courseData.ddcs_campus_entity.find(
      c => normalize(c.name) === normalize(campusName)
    );
    if (!hit) return null;
    return {
      is_department_used_flag: Boolean(hit.is_department_used_flag),
      is_division_used_flag: Boolean(hit.is_division_used_flag),
    };
  }

  buildParameterStrings() {
    const results = {
      selectedCampus: '',
      selectedTermId: '',
      selectedDivision: '',
      selectedDepartment: '',
      selectedcourse: '',
      selectedsection: '',
    };
    // @ts-ignore
    this.selectedFilters.forEach((filterObj, index) => {
      const separator = index === this.selectedFilters.length - 1 ? '' : '|';

      Object.keys(results).forEach(key => {
        const value = filterObj[key] || '';

        
        if (key === 'selectedTermId') {
          if (!results[key]) { 
            results[key] = value; 
          }
        } else {
          results[key] += value + separator; 
        }
      });
    });

    // FM-2542: omit division/department from shareable URL when campus does not use them.
    // Filters still keep those fields for DDCS resolution (student-ID path).
    const campusFlags = this._campusFlagsForSelectedCampus();
    if (campusFlags) {
      if (!campusFlags.is_department_used_flag) {
        results.selectedDepartment = '';
      }
      if (!campusFlags.is_division_used_flag) {
        results.selectedDivision = '';
      }
    }

    return results;
    
  }

  // @ts-ignore
  updateURLWithParameters(paramStrings, forStudentIdFlow = null) {
    const params = new URLSearchParams(window.location.search);

    const isStudentIdUrl = Boolean(forStudentIdFlow);

    if (this.selectedFilters.length > 0) {
      const existingShopBy =
        params.get(this.URL_PARAMS.SHOP_BY) || this._preservedShopByFromUrl || '';
      let selectedCampus = isStudentIdUrl ? 'studentid' : 'course';
      if (!isStudentIdUrl) {
        if (existingShopBy.includes('discoverview')) {
          selectedCampus = existingShopBy;
        } else if (existingShopBy === 'courseRefId') {
          selectedCampus = 'courseRefId';
        }
      }
      const selectedDivision = paramStrings.selectedDivision;
      const selectedDepartment = paramStrings.selectedDepartment;
      const selectedcourse = paramStrings.selectedcourse;
      const selectedcourseRefId = paramStrings.selectedcourseRefId;
      const selectedsection = paramStrings.selectedsection;
      const selectedTermId = paramStrings.selectedTermId;
      cmrpPersistFlowFromUrlState(isStudentIdUrl ? 'student-id' : 'course-builder');
      params.delete('cmrp_flow');
      // URLSearchParams encodes on serialize; do not pre-encode or & becomes %2526 in the bar.
      params.set(this.URL_PARAMS.SHOP_BY, selectedCampus);
      if (selectedDivision) {
        params.set(this.URL_PARAMS.DIVISION_DISPLAY_NAME, selectedDivision);
      } else {
        params.delete(this.URL_PARAMS.DIVISION_DISPLAY_NAME);
      }
      if (selectedDepartment) {
        params.set(this.URL_PARAMS.DEPARTMENT_DISPLAY_NAME, selectedDepartment);
      } else {
        params.delete(this.URL_PARAMS.DEPARTMENT_DISPLAY_NAME);
      }
      params.set(this.URL_PARAMS.COURSE_DISPLAY_NAME, selectedcourse);
      if (
        selectedcourseRefId &&
        selectedcourseRefId !== '' &&
        selectedcourseRefId !== null &&
        selectedcourseRefId !== undefined &&
        selectedcourseRefId !== 'null' &&
        selectedcourseRefId !== 'undefined'
      ) {
        params.set(this.URL_PARAMS.COURSE_REF_ID, selectedcourseRefId);
      }
      params.set(this.URL_PARAMS.SECTION_DISPLAY_NAME, selectedsection);
      params.set(this.URL_PARAMS.TERM_ID, selectedTermId);

     
    } else {
      // Always skip stripping while restore is in flight — including student-id session
      // rehydration (typed id present, selectedFilters still empty), which previously cleared deep links.
      if (this.isUrlRestorePending()) {
        return;
      }
      [
        this.URL_PARAMS.SHOP_BY,
        this.URL_PARAMS.DIVISION_DISPLAY_NAME,
        this.URL_PARAMS.DEPARTMENT_DISPLAY_NAME,
        this.URL_PARAMS.COURSE_DISPLAY_NAME,
        this.URL_PARAMS.COURSE_REF_ID,
        this.URL_PARAMS.SECTION_DISPLAY_NAME,
        this.URL_PARAMS.TERM_ID,
      ].forEach(param => params.delete(param));
      params.delete('cmrp_flow');
    }


    
    window.history.replaceState(
      {},
      '',
      `${window.location.pathname}?${params}`
    );
    const currentSearch = window.location.search;
    // @ts-ignore
    const searchData = currentSearch
      .replaceAll('%2520', '%20')
      .replaceAll('%257C', '%7C')
      .replaceAll('%2526', '%26');
    
    window.history.replaceState(
      {},
      '',
      `${window.location.pathname}${searchData}`
    );
    console.info('[CMRP url] updateURLWithParameters done', {
      search: window.location.search.slice(0, 200),
    });
    // Keep restoration snapshot in sync with the address bar.
    this.parseURLParameters(true);
    if (typeof window.anchorCmrpProductsPanel === 'function') {
      window.anchorCmrpProductsPanel();
    }
  }

  // @ts-ignore
  setOrDeleteParam(params, key, value) {
    if (value) {
      params.set(key, value);
    } else {
      params.delete(key);
    }
  }

  // @ts-ignore
  async restoreFormStateFromURL(
    termsIds,
    divisions,
    departments,
    courses,
    courseRefIds,
    sections
  ) {
    cmrpUrlRestoreDebug('restoreFormStateFromURL.start', {
      termSlots: termsIds?.length,
      divisions: divisions?.length,
      departments: departments?.length,
      courses: courses?.length,
      courseRefIds: courseRefIds?.length,
      sections: sections?.length,
    });
    this.clearExistingFilters();
    
    const { filters, campusInfo, termClosedInfo } = await this.buildFiltersFromURLParams(
      termsIds,
      divisions,
      departments,
      courses,
      courseRefIds,
      sections
    );

    // Check if term is closed
    if (termClosedInfo) {
      this.showTermClosedError(termClosedInfo);
      this.urlParamsToRestore = null;
      return;
    }

    if (filters.length === 0) {
      cmrpUrlRestoreDebug('restoreFormStateFromURL.noFilters', {
        message: 'buildFiltersFromURLParams returned 0 filters',
      });
      this.urlParamsToRestore = null;
      this.showEmptyStateAndHideLoading();
      return;
    }

    cmrpUrlRestoreDebug('restoreFormStateFromURL.campusInfo', {
      campus: campusInfo?.campus,
      term: campusInfo?.term,
      termId: campusInfo?.termEntity?.term_id,
      campusEntityId: campusInfo?.campusEntity?.campus_entity_id,
    });

    // Show subtitle and SHOP NOW button since term is open
    this.showTermOpenElements();

    this.selectedFilters.push(...filters);
    filters.forEach(filter => this.addLabelCallback(filter));
    await this.restoreDropdownsAndUI(campusInfo);
    this.setURLSearchParams();
  }

  clearExistingFilters() {
    this.selectedFilters.length = 0;
    ['course-list', 'filtered-products'].forEach(id => {
      const element = document.getElementById(id);
      if (element) element.innerHTML = '';
    });
  }

  async buildFiltersFromURLParams(
    // @ts-ignore
    termsIds,
    // @ts-ignore
    divisions,
    // @ts-ignore
    departments,
    // @ts-ignore
    courses,
    // @ts-ignore
    courseRefIds,
    // @ts-ignore
    sections
  ) {
    const filters = [];
    let campusInfo = null;
    let termClosedInfo = null;

    const maxLength = Math.max(
      termsIds.length,
      divisions.length,
      departments.length,
      courses.length,
      courseRefIds.length,
      sections.length
    );

    for (let i = 0; i < maxLength; i++) {
      const courseData = {
        termId: termsIds[i] || '',
        rawTermId: this.urlParamsToRestore?.rawTermId || '',
        division: divisions[i] || '',
        department: departments[i] || '',
        course: courses[i] || '',
        courseRefId: courseRefIds[i] || '',
        section: sections[i] || '',
      };

      const hasFullCourseLine = courseData.department && courseData.course && courseData.section;
      const hasFullCourseRefLine =
        courseData.courseRefId &&
        courseData.courseRefId !== '' &&
        courseData.courseRefId !== null &&
        courseData.courseRefId !== undefined &&
        courseData.courseRefId !== 'null' &&
        courseData.courseRefId !== 'undefined';
      // Skip filter building when no full course line, but still check term closed if we have termId
      if (!hasFullCourseLine && !hasFullCourseRefLine) {
        if (courseData.termId) {
          const entities = await this.findMatchingEntities(courseData);
          if (entities && entities.termClosed === true) {
            const { campusEntity, termEntity } = entities;
            if (!termClosedInfo) {
              termClosedInfo = {
                campus: campusEntity.name,
                term: termEntity.name,
                department: courseData.department || '',
                course: courseData.course || '',
                campusEntity,
                termEntity,
              };
            }
          }
        }
        continue;
      }

      const entities = await this.findMatchingEntities(courseData);
      if (!entities) continue;

      const { campusEntity, termEntity, termClosed } = entities;

      // Check if term is closed
      if (termClosed === true) {
        if (!termClosedInfo) {
          termClosedInfo = {
            campus: campusEntity.name,
            term: termEntity.name,
            department: courseData.department,
            course: courseData.course,
            campusEntity,
            termEntity,
          };
        }
        // Don't add filters for closed terms, but store the info
        continue;
      }

      if (!campusInfo) {
        campusInfo = {
          campus: campusEntity.name,
          term: termEntity.name,
          campusEntity,
          termEntity,
        };
      }

      const fo = await this.createFilterObject(
        courseData,
        campusEntity,
        termEntity,
        hasFullCourseRefLine
      );
      if (fo) filters.push(fo);
    }

    return { filters, campusInfo, termClosedInfo };
  }
  /**
   * @param {any} metaobjectType
   * @param {any} query
   */
  async fetchMetaobjects(metaobjectType, query) {
    if (typeof window !== 'undefined' && window.fetchMetaobjectsOnce) {
      return window.fetchMetaobjectsOnce(metaobjectType, query);
    }

    const proxyPath = '/apps/shopifyData/metaobjects';
    const url = `${proxyPath}?type=${metaobjectType}&query=${query}`;

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.success) {
        const activeMetaobjects = result.data.filter(
          item => item.status === 'ACTIVE',
        );
        return activeMetaobjects;
      } else {
        throw new Error(result.error || 'Failed to fetch metaobjects');
      }
    } catch (error) {
      console.error('Error fetching metaobjects:', error);
      throw error;
    }
  }
  /**
   * @param {any} queryData
   */
  async fetchProducts(queryData) {
    if (typeof window !== 'undefined' && window.fetchProductsOnce) {
      return window.fetchProductsOnce(queryData);
    }

    const proxyPath = '/apps/shopifyData/products';
    const url = `${proxyPath}?query=${queryData}`;

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.success) {
        return result.products;
      } else {
        throw new Error(result.error || 'Failed to fetch products');
      }
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  }
  /**
   * Fetch campus metaobject by campus_entity_id when not in config
   * @param {string} campusEntityId
   * @returns {Promise<object|null>} campus metaobject or null
   */
  async fetchCampusByEntityId(campusEntityId) {
    if (!campusEntityId) return null;
    const query = "fields.campus_entity_id:'" + campusEntityId + "'";
    const campuses = await this.fetchMetaobjects('ddcs_campus', query);
    return campuses && campuses.length > 0 ? campuses[0] : null;
  }

  /**
   * @param {{ termId: any; division?: any; department: any; course: any; section: any; }} courseData
   */
  async findMatchingEntities(courseData) {
    // First check if term exists (without is_term_open_flag filter to check its status)
    const urlParams = new URLSearchParams(window.location.search);
    const storeNumber =
      cmrpSafeDecodeURIComponent(urlParams.get('merfnbr')) ||
      cmrpSafeDecodeURIComponent(urlParams.get('bookstoreId'));

      const termIdTrim =
      courseData.termId != null ? String(courseData.termId).trim() : '';
    if (!termIdTrim) {
      return false;
    }
    const rawTermId =
      courseData.rawTermId != null
        ? String(courseData.rawTermId).trim()
        : new URLSearchParams(window.location.search)
            .get(this.URL_PARAMS.TERM_ID)
            ?.trim() ?? '';
    const termIdFirstCap = termIdTrim
      ? termIdTrim.charAt(0).toUpperCase() + termIdTrim.slice(1)
      : '';
    const termIdVariants = [termIdTrim];

    termIdVariants.push(rawTermId);
    if (termIdFirstCap) {
      termIdVariants.push(termIdFirstCap);
    }
    
    const termOrClauses = termIdVariants.flatMap(id => [
      "fields.term:'" + id + "'",
      "fields.term_id:'" + id + "'",
    ]);

    let queryDataAll = 
    '(' + termOrClauses.join(' OR ') + ') ';

    if (storeNumber) {
      queryDataAll += " fields.store_number:'" + storeNumber + "'";
    }
    queryDataAll += ' fields.disabled_flag:false';
    const allTerms = await this.fetchMetaobjects('ddcs_term', queryDataAll);
    
    
    
    if(allTerms && allTerms.length > 0){
      let termEntity = allTerms[0];
          
      let campusEntity = this.ddcsCampusEntity.find(
        // @ts-ignore
        c => c.campus_entity_id === termEntity.campus_entity_id
      );
      // Fallback: fetch campus from metaobjects API by campus_entity_id when not in config
      if (!campusEntity && termEntity.campus_entity_id) {
        campusEntity = await this.fetchCampusByEntityId(termEntity.campus_entity_id);
      }
      if (!campusEntity && termEntity.campus_entity_id) {
        campusEntity = {
          name: 'Campus',
          campus_entity_id: termEntity.campus_entity_id
        };
      }

      // Check if term is closed (explicitly false) or forced closed for testing
      const isTermClosed = termEntity.is_term_open_flag === false || termEntity.is_term_open_flag === 'false';
      
      if(isTermClosed) {
        return campusEntity && termEntity ? { campusEntity, termEntity, termClosed: true } : null;
      }

      return campusEntity && termEntity ? { campusEntity, termEntity, termClosed: false } : null;
    }

    return false;
    
  }

  // @ts-ignore
  async findSectionByCourseRefId(courseData, termEntity) {
    const courseRefId = courseData?.courseRefId;
    if (!courseRefId) return null;

    const queryDataAll = `fields.section_key:'${courseRefId}' fields.disabled_flag:false`;
    const allSections = await this.fetchMetaobjects(
      'ddcs_section',
      queryDataAll
    );
    if (allSections && allSections.length > 0) {
      const sectionEntity = termEntity?.term_id
      ? allSections?.find(section => section.term_id === termEntity.term_id)
      : allSections?.[0];
      if (!sectionEntity) return null;

      let sectionData = {};

      const courseEntity = await this.fetchMetaobjects(
        'ddcs_course',
        `fields.course_id:'${sectionEntity.course_id}' fields.disabled_flag:false`
      );
      if (courseEntity && courseEntity.length > 0) {
        const courseEntityData = courseEntity[0];
        sectionData.course = courseEntityData.coursenumber;

        const departmentEntity = await this.fetchMetaobjects(
          'ddcs_department',
          `fields.campus_department_id:'${courseEntityData.campus_department_id}' fields.disabled_flag:false`
        );
        if (departmentEntity && departmentEntity.length > 0) {
          const departmentEntityData = departmentEntity[0];
          sectionData.department = departmentEntityData.name;

          const divisionEntity = await this.fetchMetaobjects(
            'ddcs_division',
            `fields.campus_division_id:'${departmentEntityData.campus_division_id}' fields.disabled_flag:false`
          );
          if (divisionEntity && divisionEntity.length > 0) {
            const divisionEntityData = divisionEntity[0];
            sectionData.division = divisionEntityData.name;
          }
        }
      }

      sectionData.section_id = sectionEntity.section_id;
      sectionData.section = sectionEntity.name;
      sectionData.selectedsectionGid = sectionEntity.gid || '';
      sectionData.adoption_status =
        sectionEntity.adoption_status != null &&
        sectionEntity.adoption_status !== ''
          ? String(sectionEntity.adoption_status)
          : '';

      return sectionData;
    }

    return null;
  }

  // @ts-ignore
  async createFilterObject(
    courseData,
    campusEntity,
    termEntity,
    hasFullCourseRefLine
  ) {
    if (hasFullCourseRefLine) {
      const courseRefIdData = await this.findSectionByCourseRefId(courseData, termEntity);
      if (!courseRefIdData) return null;

      const base = {
        selectedDepartment: cmrpSafeDecodeURIComponent(
          courseRefIdData.department
        ),
        selectedCampus: cmrpSafeDecodeURIComponent(campusEntity.name),
        selectedTerm: cmrpSafeDecodeURIComponent(termEntity.name),
        selectedTermId: cmrpSafeDecodeURIComponent(termEntity.term_id),
        selectedcourse: cmrpSafeDecodeURIComponent(courseRefIdData.course),
        selectedsection: cmrpSafeDecodeURIComponent(
          courseRefIdData.section
        ),
        selectedsectionId: cmrpSafeDecodeURIComponent(
          courseRefIdData.section_id
        ),
        selectedDivision: cmrpSafeDecodeURIComponent(courseRefIdData.division),
        selectedsectionGid: courseRefIdData.selectedsectionGid || '',
        adoption_status: courseRefIdData.adoption_status || '',
      };

      if (this._cmrpUrlRestoreTargetStudentIdForm) {
        // @ts-ignore — keeps course-builder chips empty (see syncBubblesFromFilters).
        base.fromStudentId = true;
      }

      return base;
    }

    const base = {
      selectedDepartment: cmrpSafeDecodeURIComponent(courseData.department),
      selectedCampus: cmrpSafeDecodeURIComponent(campusEntity.name),
      selectedTerm: cmrpSafeDecodeURIComponent(termEntity.name),
      selectedTermId: cmrpSafeDecodeURIComponent(termEntity.term_id),
      selectedcourse: cmrpSafeDecodeURIComponent(courseData.course),
      selectedsection: cmrpSafeDecodeURIComponent(courseData.section),
      selectedDivision: cmrpSafeDecodeURIComponent(courseData.division),
    };

    if (this._cmrpUrlRestoreTargetStudentIdForm) {
      // @ts-ignore — keeps course-builder chips empty (see syncBubblesFromFilters).
      base.fromStudentId = true;
    }

    return base;
  }
  async fetchMetaobjectsData(termId, campusId) {
    // Usa helper global com cache quando disponível
    if (typeof window !== 'undefined' && window.fetchFilteredDataOnce) {
      return window.fetchFilteredDataOnce(termId, campusId);
    }

    // Fallback para implementação antiga (caso helper não esteja disponível)
    const proxyPath = '/apps/shopifyData/getFilteredData';
    const url = `${proxyPath}?campus_entity_id=${campusId}&term_id=${termId}`;

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.success) {
        return result.data;
      } else {
        throw new Error(result.error || 'Failed to fetch metaobjects');
      }
    } catch (error) {
      console.error('Error fetching metaobjects:', error);
      throw error;
    }
  }
  // @ts-ignore
  async restoreDropdownsAndUI(campusInfo) {
    if (!campusInfo) {
      cmrpUrlRestoreDebug('restoreDropdownsAndUI.noCampusInfo', {});
      // @ts-ignore
      this.callIfExists(window.showEmptyState);
      return;
    }

    try {
      cmrpUrlRestoreDebug('restoreDropdownsAndUI.fetch', {
        term_id: campusInfo.termEntity?.term_id,
        campus_entity_id: campusInfo.termEntity?.campus_entity_id,
      });
      window.courseData.ddcs_campus_division = [];
      window.courseData.ddcs_campus_department = [];
      window.courseData.ddcs_course = [];
      window.courseData.ddcs_section = [];

      const dataFilters = await this.fetchMetaobjectsData(campusInfo.termEntity.term_id, campusInfo.termEntity.campus_entity_id);

      window.courseData.ddcs_campus_division = dataFilters.ddcs_campus_division;
      window.courseData.ddcs_campus_department = dataFilters.ddcs_campus_department;
      window.courseData.ddcs_course = dataFilters.ddcs_course;
      window.courseData.ddcs_section = dataFilters.ddcs_section;

      cmrpUrlRestoreDebug('restoreDropdownsAndUI.afterFetch', {
        divisionRows: (dataFilters.ddcs_campus_division || []).length,
        departmentRows: (dataFilters.ddcs_campus_department || []).length,
      });

      this.setCampusDropdown(campusInfo.campus, campusInfo.campusEntity);
      await this.setTermDropdown(
        campusInfo.campus,
        campusInfo.term,
        campusInfo.termEntity
      );
      if (!this._cmrpUrlRestoreTargetStudentIdForm) {
        this.restoreAllFormFieldsFromURL();
      } else {
        this.urlParamsToRestore = null;
        if (
          typeof window !== 'undefined' &&
          typeof window.cmrpTruncateCmrpFilterSelectsIn === 'function'
        ) {
          window.cmrpTruncateCmrpFilterSelectsIn(
            document.getElementById('filters-section'),
          );
        }
      }

      const isCmrpResults =
        document.body?.classList?.contains('course-materials-page') === true;
      const isMobile = window.innerWidth < 968;
      // @ts-ignore
      if ((!isMobile || isCmrpResults) && window.courseMaterialsSidebar) {
        // @ts-ignore
        window.courseMaterialsSidebar.openSidePanel();
      }

      const refreshOut = this.refreshProductsCallback(this.selectedFilters);
      if (refreshOut && typeof refreshOut.then === 'function') {
        await refreshOut;
      }
    } catch (error) {
      console.error('Error in restoreDropdownsAndUI:', error);
      // @ts-ignore
      this.callIfExists(window.hideLoadingState);
    }
  }

  // @ts-ignore
  setCampusDropdown(campusName, campusEntity) {
    const campusSelect = this.cmrpUrlRestoreCampusTermSelect('campus');
    if (!campusSelect) return;

    // @ts-ignore
    campusSelect.value = campusName;

    if (typeof window !== 'undefined') {
      // @ts-ignore
      window.campus_entity_id = campusEntity.campus_entity_id;
      // @ts-ignore
      window.show_division =
        typeof window.cmrpResolveShowDivision === 'function'
          ? window.cmrpResolveShowDivision(campusEntity.is_division_used_flag)
          : campusEntity.is_division_used_flag;
      console.log('[CMRP Division] url-state setCampusDropdown', {
        campusName,
        campus_entity_id: campusEntity.campus_entity_id,
        perCampusFlag: campusEntity.is_division_used_flag,
        show_division: window.show_division,
      });
    }

    // @ts-ignore
    if (window.courseMaterialsSidebar) {
      // @ts-ignore
      window.courseMaterialsSidebar.campus_entity_id =
        campusEntity.campus_entity_id;
      // @ts-ignore
      window.courseMaterialsSidebar.show_division =
        typeof window.cmrpResolveShowDivision === 'function'
          ? window.cmrpResolveShowDivision(campusEntity.is_division_used_flag)
          : campusEntity.is_division_used_flag;
    }
  }

  // @ts-ignore
  async setTermDropdown(campusName, termName, termEntity) {
    const termSelect = this.cmrpUrlRestoreCampusTermSelect('term');
    if (!termSelect) return;

    await this.populateTermsForCampus(campusName);
    // @ts-ignore
    //termSelect.value = termName;
    for (let i = 0; i < termSelect.options.length; i++) {
      termSelect.options[i].selected = false;
    }
    const options = termSelect.options;
    let matched = false;
    for (let i = 0; i < options.length; i++) {
      if (
        decodeCmrpLabel(cmrpOptionLabelForMatch(options[i])) ===
        decodeCmrpLabel(termName)
      ) {
        options[i].selected = true;
        matched = true;
        break;
      }
    }
    if (!matched && termEntity?.term_id) {
      const tid = String(termEntity.term_id);
      for (let i = 0; i < options.length; i++) {
        if (String(options[i].value) === tid) {
          options[i].selected = true;
          matched = true;
          break;
        }
      }
    }

    if (typeof window !== 'undefined') {
      // @ts-ignore
      window.term_id = termEntity.term_id;
    }

    // @ts-ignore
    if (window.courseMaterialsSidebar) {
      // @ts-ignore
      window.courseMaterialsSidebar.term_id = termEntity.term_id;
      // @ts-ignore
      window.courseMaterialsSidebar.checkCampusTermSelection();
    }

    if (!this._cmrpUrlRestoreTargetStudentIdForm) {
      this.triggerDepartmentCascadeForRestore();
    }
  }

  // @ts-ignore
  async populateTermsForCampus(campusName) {
    const termSelect = this.cmrpUrlRestoreCampusTermSelect('term');
    if (!termSelect) return;

    termSelect.innerHTML = '<option value="">Term</option>';

    const normalize = value =>
      String(value ?? '')
        .toLowerCase()
        .replace(/\s+/g, '');
    const campusPool =
      (typeof window !== 'undefined' &&
        Array.isArray(window.courseData?.ddcs_campus_entity) &&
        window.courseData.ddcs_campus_entity.length > 0 &&
        window.courseData.ddcs_campus_entity) ||
      this.ddcsCampusEntity ||
      [];
    const normLabel = value => normalize(decodeCmrpLabel(value));
    const campusKey = normLabel(String(campusName ?? '').trim());
    // @ts-ignore
    const campus = campusPool.find(c => normLabel(c.name) === campusKey);
    if (!campus) return;
    //const queryData = "fields.campus_entity_id:'"+campus.campus_entity_id+"' fields.disabled_flag:false fields.is_term_open_flag:true"
    const filteredTerms = window.courseData.ddcs_term.filter(
      term => normalize(term.campus_entity_id) === normalize(campus.campus_entity_id)
    );
    const sortValuesByName = (a, b) => {
      const nameA = decodeCmrpLabel(a.name);
      const nameB = decodeCmrpLabel(b.name);

      const isNumA = !isNaN(nameA.charAt(0));
      const isNumB = !isNaN(nameB.charAt(0));
      
      if (isNumA && isNumB) {
        return parseInt(nameA) - parseInt(nameB); 
      }
      
      if (isNumA) {
        return -1; 
      }
      
      if (isNumB) {
        return 1; 
      }
      
      return nameA.localeCompare(nameB, undefined, { sensitivity: 'base' });
    };
    const sortedValues = filteredTerms.sort(sortValuesByName);
    

    if (filteredTerms.length > 0) {
      // @ts-ignore
      termSelect.disabled = false;
      // @ts-ignore
      filteredTerms.forEach(term => {
        const option = document.createElement('option');
        option.value = term.term_id;
        if (
          typeof window !== 'undefined' &&
          typeof window.cmrpStampOptionFullLabel === 'function'
        ) {
          window.cmrpStampOptionFullLabel(option, decodeCmrpLabel(term.name));
        } else {
          option.textContent = decodeCmrpLabel(term.name);
        }
        termSelect.appendChild(option);
      });
    }
  }

  restoreAllFormFieldsFromURL() {
    
    // @ts-ignore
    if (!this.urlParamsToRestore || !window.courseMaterialsSidebar) return;
    
    const { divisions, departments, courses, sections } =
      this.urlParamsToRestore;
    const values = {
      division: cmrpSafeDecodeURIComponent(divisions[0]),
      department: cmrpSafeDecodeURIComponent(departments[0]),
      course: cmrpSafeDecodeURIComponent(courses[0]),
      section: cmrpSafeDecodeURIComponent(sections[0]),
    };
    //console.log("values_0 ==> ", values)
    setTimeout(() => this.restoreFieldsCascade(values), 100);
  }

  // @ts-ignore
  async restoreFieldsCascade(values) {
    // @ts-ignore
    const sidebar = window.courseMaterialsSidebar;
    const fields = {
      division: document.getElementById(cmrpCbCourseLineSelectId('division')),
      department: document.getElementById(cmrpCbCourseLineSelectId('department')),
      course: document.getElementById(cmrpCbCourseLineSelectId('course')),
      section: document.getElementById(cmrpCbCourseLineSelectId('section')),
    };

    const show_division =
      (typeof window.cmrpIsDivisionUsedGlobally === 'function'
        ? window.cmrpIsDivisionUsedGlobally()
        : true) && (window?.show_division || false);

    console.log('[CMRP Division] url-state restoreFieldsCascade', {
      globalFlag:
        typeof window.cmrpIsDivisionUsedGlobally === 'function'
          ? window.cmrpIsDivisionUsedGlobally()
          : true,
      windowShowDivision: window?.show_division,
      sidebarShowDivision: sidebar?.show_division,
      show_division,
      __cmrpIsDivisionUsedFlag: window.__cmrpIsDivisionUsedFlag,
      hasDivisionValue: Boolean(values.division),
    });

    cmrpUrlRestoreDebug('restoreFieldsCascade', {
      resolvedIds: {
        division: cmrpCbCourseLineSelectId('division'),
        department: cmrpCbCourseLineSelectId('department'),
        course: cmrpCbCourseLineSelectId('course'),
        section: cmrpCbCourseLineSelectId('section'),
      },
      found: {
        division: Boolean(fields.division),
        department: Boolean(fields.department),
        course: Boolean(fields.course),
        section: Boolean(fields.section),
      },
      show_division,
      valuesPreview: {
        division: String(values.division || '').slice(0, 80),
        department: String(values.department || '').slice(0, 80),
        course: String(values.course || '').slice(0, 80),
        section: String(values.section || '').slice(0, 80),
      },
    });

    // Step 1: Division (if needed)
    if (values.division && show_division && fields.division) {
      await sidebar.populateDivision();
      setTimeout(async () => {
        if (fields.division){
          // @ts-ignore
          fields.division.value = values.division;
          // @ts-ignore
          const options = fields.division.options; 
          
          for (let i = 0; i < options.length; i++) {
              if (
                decodeCmrpLabel(cmrpOptionLabelForMatch(options[i])) ===
                decodeCmrpLabel(values.division)
              ) {
                  options[i].selected = true; 
                  break; 
              }
          }
        } 
        await this.continueWithDepartment(sidebar, fields, values);
      }, 50);
    } else {
      cmrpUrlRestoreDebug('restoreFieldsCascade.skipDivisionStep', {
        hasDivisionValue: Boolean(values.division),
        show_division,
        hasDivisionEl: Boolean(fields.division),
      });
      await this.continueWithDepartment(sidebar, fields, values);
    }
  }

  // @ts-ignore
  async continueWithDepartment(sidebar, fields, values) {
    // Step 2: Department
    await sidebar.populateDepartments();
    setTimeout(async () => {
      if (values.department && fields.department) {
        for (let i = 0; i < fields.department.options.length; i++) {
          fields.department.options[i].selected = false;
        }
        const options = fields.department.options;
        for (let i = 0; i < options.length; i++) {
          if (
            decodeCmrpLabel(cmrpOptionLabelForMatch(options[i])) ===
            decodeCmrpLabel(values.department)
          ) {
              options[i].selected = true; 
              break; 
          }
        }
      }
      await this.continueWithCourse(sidebar, fields, values);
    }, 50);
  }

  // @ts-ignore
  async continueWithCourse(sidebar, fields, values) {
    // Step 3: Course
    if (values.course && fields.course) {
      await sidebar.populateCourses();
      setTimeout(async () => {
        
        for (let i = 0; i < fields.course.options.length; i++) {
          fields.course.options[i].selected = false;
        }
        const options = fields.course.options;
        for (let i = 0; i < options.length; i++) {
          if (
            decodeCmrpLabel(cmrpOptionLabelForMatch(options[i])) ===
            decodeCmrpLabel(values.course)
          ) {
              options[i].selected = true; 
              break; 
          }
        }
        await this.continueWithSection(sidebar, fields, values);
      }, 50);
    } else {
      await this.finishRestore(sidebar);
    }
  }

  // @ts-ignore
  async continueWithSection(sidebar, fields, values) {
    // Step 4: Section
    if (values.section && fields.section) {
      await sidebar.populateSections();
      setTimeout(() => {
        for (let i = 0; i < fields.section.options.length; i++) {
          fields.section.options[i].selected = false;
        }
        const options = fields.section.options;
        for (let i = 0; i < options.length; i++) {
          if (
            decodeCmrpLabel(cmrpOptionLabelForMatch(options[i])) ===
            decodeCmrpLabel(values.section)
          ) {
              options[i].selected = true; 
              break; 
          }
        }
        this.finishRestore(sidebar);
      }, 50);
    } else {
      this.finishRestore(sidebar);
    }
  }

  // @ts-ignore
  async finishRestore(sidebar) {
    // Update button state after all fields are set
    //sidebar.updateAddCourseButtonState();
    this.urlParamsToRestore = null;
    if (
      typeof window !== 'undefined' &&
      typeof window.cmrpTruncateCmrpFilterSelectsIn === 'function'
    ) {
      window.cmrpTruncateCmrpFilterSelectsIn(
        document.getElementById('filters-section'),
      );
    }
  }

  triggerDepartmentCascadeForRestore() {
    const divisionFieldId =
      typeof window !== 'undefined' && typeof window.cmrpId === 'function'
        ? window.cmrpId('division_field', 'cb')
        : 'division_field';
    const divisionField = document.getElementById(divisionFieldId);
    const show_division =
      (typeof window.cmrpIsDivisionUsedGlobally === 'function'
        ? window.cmrpIsDivisionUsedGlobally()
        : true) && (window?.show_division || false);

    console.log('[CMRP Division] url-state triggerDepartmentCascadeForRestore', {
      globalFlag:
        typeof window.cmrpIsDivisionUsedGlobally === 'function'
          ? window.cmrpIsDivisionUsedGlobally()
          : true,
      windowShowDivision: window?.show_division,
      show_division,
      __cmrpIsDivisionUsedFlag: window.__cmrpIsDivisionUsedFlag,
    });

    if (divisionField) {
      divisionField.hidden = !show_division;
      divisionField.style.display = show_division ? 'block' : 'none';
    }
  }
  async checkSession() {
    if (typeof window.cmrpGlobalCheckSession === 'function') {
      return window.cmrpGlobalCheckSession();
    }
    const token = sessionStorage.getItem('sessionToken');
    if (!token) return false;

    try {
      const response = await fetch('/apps/shopifyData/session/check', {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) throw new Error(`Error: ${response.status}`);

      return await response.json();
    } catch (error) {
      console.error('Error checking session:', error);
    }
  }
  async attemptURLRestoration() {
    // @ts-ignore
    if (!window.courseMaterialsSidebar) {
      setTimeout(() => this.attemptURLRestoration(), 100);
      return;
    }

    this._isUrlRestoreInProgress = true;
    try {
      // Single-campus / single-term sidebar init calls clearAllUserSelections → setURLSearchParams,
      // which strips query params and re-parses an empty urlParamsToRestore before this runs.
      if (this._initialUrlRestoreSnapshot) {
        const snap = this._initialUrlRestoreSnapshot;
        const snapHas = [
          snap.termsIds,
          snap.divisions,
          snap.departments,
          snap.courses,
          snap.courseRefIds,
          snap.sections,
        ].some(arr => Array.isArray(arr) && arr.length > 0);
        if (snapHas) {
          this.urlParamsToRestore = {
            rawTermId: snap.rawTermId ?? null,
            termsIds: [...snap.termsIds],
            divisions: [...snap.divisions],
            departments: [...snap.departments],
            courses: [...snap.courses],
            courseRefIds: [...snap.courseRefIds],
            sections: [...snap.sections],
          };
        }
      }

      if (!this.urlParamsToRestore) {
        cmrpUrlRestoreDebug('attemptURLRestoration.noSnapshot', {});
        this.showEmptyStateAndHideLoading();
        return;
      }

      const {
        termsIds,
        divisions,
        departments,
        courses,
        courseRefIds,
        sections,
      } = this.urlParamsToRestore;

      cmrpUrlRestoreDebug('attemptURLRestoration.snapshot', {
        termsIds: termsIds?.length,
        divisions: divisions?.length,
        departments: departments?.length,
        courses: courses?.length,
        courseRefIds: courseRefIds?.length,
        sections: sections?.length,
      });
      const hasCourseParams = [
        termsIds,
        divisions,
        departments,
        courses,
        courseRefIds,
        sections,
      ].some(arr => arr.length > 0);

      const session_check = await this.checkSession();

      const forcedFlowPref =
        typeof window.readCmrpInitialFlowPreference === 'function'
          ? window.readCmrpInitialFlowPreference()
          : '';
      const courseRefDeepLink =
        Array.isArray(courseRefIds) && courseRefIds.length > 0;
      const skipSessionForCourseRestore =
        forcedFlowPref === 'course-builder' || courseRefDeepLink;

      let resolvedStudentId = null;
      if (!skipSessionForCourseRestore) {
        if (session_check && session_check.status && session_check.sessionID) {
          resolvedStudentId = session_check.sessionID;
        } else if (typeof window.consumeCmrpStudentIdPrefill === 'function') {
          const pref = window.consumeCmrpStudentIdPrefill();
          resolvedStudentId = pref || null;
        } else {
          try {
            const k = 'cmrp_student_id_prefill';
            const raw = sessionStorage.getItem(k);
            if (raw) {
              sessionStorage.removeItem(k);
              resolvedStudentId = String(raw).trim() || null;
            }
          } catch (e) {
            /* ignore */
          }
        }
      }

      const resolveStudentIdUrlRestoreTarget = () => {
        if (resolvedStudentId && hasCourseParams && !skipSessionForCourseRestore) {
          return true;
        }
        return Boolean(
          typeof window.cmrpResolveProductsAnchorUnderStudentForm ===
            'function' && window.cmrpResolveProductsAnchorUnderStudentForm(),
        );
      };

      if (resolvedStudentId) {
        this._cmrpUrlRestoreTargetStudentIdForm = resolveStudentIdUrlRestoreTarget();
        this.restoreStudentIdFromURL(resolvedStudentId, hasCourseParams);
        if (hasCourseParams) {
          await this.restoreFormStateFromURL(
            termsIds,
            divisions,
            departments,
            courses,
            courseRefIds,
            sections
          );
        }
        return;
      }

      if (hasCourseParams) {
        this._cmrpUrlRestoreTargetStudentIdForm = resolveStudentIdUrlRestoreTarget();
        await this.restoreFormStateFromURL(
          termsIds,
          divisions,
          departments,
          courses,
          courseRefIds,
          sections
        );
      } else {
        this.showEmptyStateAndHideLoading();
      }
    } finally {
      this._cmrpUrlRestoreTargetStudentIdForm = false;
      this._initialUrlRestoreSnapshot = null;
      this._deferEmptyFilterUrlStrip = false;
      this._isUrlRestoreInProgress = false;
    }
  }

  // @ts-ignore
  restoreStudentIdFromURL(studentId, hasCourseParams = false) {
    const isCmrpResults =
      document.body?.classList?.contains('course-materials-page') === true;
    const isMobile = window.innerWidth < 968;

    // @ts-ignore
    if ((!isMobile || isCmrpResults) && window.courseMaterialsSidebar) {
      // @ts-ignore
      window.courseMaterialsSidebar.openSidePanel();
    }

    // Note: Mobile drawer opening is handled by course-materials-mobile.js
    // via its restoreStudentIdFromURL() method which opens the correct drawer

    this.expandSkipSection();

    const studentIdField = document.getElementById(
      typeof window.cmrpId === 'function'
        ? window.cmrpId('student-id', 'sid')
        : 'student-id',
    );
    if (studentIdField) {
      // @ts-ignore
      studentIdField.value = studentId;
    }

    const mobileStudentIdInput = document.getElementById('mobile-student-id-input');
    if (mobileStudentIdInput) {
      // @ts-ignore
      mobileStudentIdInput.value = studentId;
    }

    const campusSelect = this._cmrpUrlRestoreTargetStudentIdForm
      ? this.cmrpUrlRestoreCampusTermSelect('campus')
      : typeof window.cmrpQueryDesktopCampusTerm === 'function'
        ? window.cmrpQueryDesktopCampusTerm('campus')
        : document.querySelector('#campus-term-dropdowns #campus');
    // @ts-ignore
    if (campusSelect && window.courseMaterialsSidebar) {
      // When deep-linking courses with an active session, `populateCampus(false)` auto-runs
      // `populateTerms` on single-campus stores — that chains into `clearAllTermSelections` and
      // races `restoreFormStateFromURL` (filters cleared / URL stripped before restore finishes).
      // @ts-ignore
      window.courseMaterialsSidebar.populateCampus(
        hasCourseParams === true,
        this._cmrpUrlRestoreTargetStudentIdForm ? 'sid' : null,
      );
      // @ts-ignore
      campusSelect.disabled = false;
    }

    // Hide course selection fields when using Student ID
    this.hideCourseSelectionFields();

    if (!hasCourseParams) {
      this.showEmptyStateAndHideLoading();
    }
  }

  hideCourseSelectionFields() {
    if (
      document.getElementById('filters-section')?.dataset?.cmrpStudentIdActive ===
      'true'
    ) {
      return;
    }
    const courseLineFields = document.querySelectorAll(
      '.cmrp-filter-form--course-builder .cmrp-course-line-fields',
    );
    courseLineFields.forEach(el => {
      el.style.display = 'none';
    });

    // Also hide the "What's the course name?" title if it exists separately
    const courseTitles = document.querySelectorAll('h3, .section-title');
    courseTitles.forEach(title => {
      if (
        title.textContent &&
        title.textContent.includes("What's the course name")
      ) {
        // @ts-ignore
        title.style.display = 'none';
      }
    });
  }

  showCourseSelectionFields() {
    if (
      document.getElementById('filters-section')?.dataset?.cmrpStudentIdActive ===
      'true'
    ) {
      return;
    }
    document
      .querySelectorAll(
        '.cmrp-filter-form--course-builder .cmrp-course-line-fields',
      )
      .forEach(el => {
        el.style.display = '';
      });

    // Show the "What's the course name?" title
    const courseTitles = document.querySelectorAll('h3, .section-title');
    courseTitles.forEach(title => {
      if (
        title.textContent &&
        title.textContent.includes("What's the course name")
      ) {
        // @ts-ignore
        title.style.display = '';
      }
    });
  }

  openMobileDrawerWithRetry(retryCount = 0, maxRetries = 10) {
    if (window.innerWidth >= 968) return; // Not mobile

    // @ts-ignore
    if (window.courseMaterialsMobileDrawer) {
      // @ts-ignore
      window.courseMaterialsMobileDrawer.open();
      return;
    }

    // Retry if mobile drawer not ready yet
    if (retryCount < maxRetries) {
      setTimeout(() => {
        this.openMobileDrawerWithRetry(retryCount + 1, maxRetries);
      }, 200);
    }
  }

  expandSkipSection() {
    const skipOptions = document.querySelector('.skip-options');
    const chevronIcon = document.querySelector('.chevron-down-icon');

    if (skipOptions && chevronIcon) {
      // @ts-ignore
      skipOptions.style.display = 'block';
      // @ts-ignore
      chevronIcon.style.transform = 'rotate(0deg)';
    }
  }

  showEmptyStateAndHideLoading() {
    // @ts-ignore
    this.callIfExists(window.hideLoadingState);
    // @ts-ignore
    this.callIfExists(window.showEmptyState);
  }

  /**
   * Show term closed error message
   * @param {{ campus: string; term: string; campusEntity: any; termEntity: any; }} termClosedInfo
   */
  showTermClosedError(termClosedInfo) {
    // Hide loading state
    // @ts-ignore
    this.callIfExists(window.hideLoadingState);
    
    // Hide initial placeholder
    const initialPlaceholder = document.getElementById('initial-placeholder');
    if (initialPlaceholder) {
      initialPlaceholder.style.display = 'none';
    }
    
    // Hide filtered products
    const filteredProducts = document.getElementById('filtered-products');
    if (filteredProducts) {
      filteredProducts.innerHTML = '';
    }
    
    // Hide subtitle and SHOP NOW button in header (desktop)
    const desktopSubtitle = document.querySelector('.header-card-discover .course-materials-subtitle');
    // @ts-ignore
    if (desktopSubtitle) desktopSubtitle.style.display = 'none';
    
    const desktopShopNow = document.querySelector('.header-card-discover .form-actions-inline-discover');
    // @ts-ignore
    if (desktopShopNow) desktopShopNow.style.display = 'none';
    
    // Hide subtitle and SHOP NOW button in header (mobile)
    const mobileSubtitle = document.querySelector('.mobile-course-trigger .mobile-main-subtitle');
    // @ts-ignore
    if (mobileSubtitle) mobileSubtitle.style.display = 'none';
    
    const mobileShopNow = document.querySelector('.mobile-course-trigger .form-actions-inline-discover');
    // @ts-ignore
    if (mobileShopNow) mobileShopNow.style.display = 'none';
    
    // Show campus-term bar when campus and term names are present (enough to render the component)
    const campusTermBar = document.getElementById('campus-term-info');
    const campusTermDisplay = document.getElementById('selected-campus-display');
    if (campusTermBar && campusTermDisplay && termClosedInfo.campus && termClosedInfo.term) {
      campusTermDisplay.textContent = `${termClosedInfo.campus} | ${termClosedInfo.term}`;
      campusTermBar.style.display = 'flex';
    }
    
    // Show term closed error message
    const noProductsFound = document.getElementById('no-products-found');
    if (noProductsFound) {
      const courseCodeElement = document.getElementById('term-closed-course-code');
      const termClosedMessage = document.getElementById('term-closed-message');
      
      // Update the course code if available (e.g., "COM 100")
      // @ts-ignore
      if (courseCodeElement && termClosedInfo.department && termClosedInfo.course) {
        // @ts-ignore
        courseCodeElement.textContent = `${termClosedInfo.department} ${termClosedInfo.course}`;
      }
      
      if (termClosedMessage) {
        termClosedMessage.style.display = 'block';
      }
      
      noProductsFound.style.display = 'block';
    }
  }

  /**
   * Show subtitle and SHOP NOW button when term is open
   */
  showTermOpenElements() {
    // Show subtitle and SHOP NOW button in header (desktop)
    const desktopSubtitle = document.querySelector('.header-card-discover .course-materials-subtitle');
    // @ts-ignore
    if (desktopSubtitle) desktopSubtitle.style.display = 'block';
    
    const desktopShopNow = document.querySelector('.header-card-discover .form-actions-inline-discover');
    // @ts-ignore
    if (desktopShopNow) desktopShopNow.style.display = 'flex';
    
    // Show subtitle and SHOP NOW button in header (mobile)
    const mobileSubtitle = document.querySelector('.mobile-course-trigger .mobile-main-subtitle');
    // @ts-ignore
    if (mobileSubtitle) mobileSubtitle.style.display = 'block';
    
    const mobileShopNow = document.querySelector('.mobile-course-trigger .form-actions-inline-discover');
    // @ts-ignore
    if (mobileShopNow) mobileShopNow.style.display = 'flex';
  }

  // @ts-ignore
  callIfExists(fn) {
    if (typeof fn === 'function') {
      fn();
    }
  }

  initialize() {
    // Show loading only when there are URL params to restore
    const { rawTermId, termsIds, divisions, departments, courses, courseRefIds, sections } =
      this.parseURLParameters(true);
    const hasURLParamsToRestore = [
      termsIds,
      divisions,
      departments,
      courses,
      courseRefIds,
      sections,
    ].some(arr => arr.length > 0);

    if (hasURLParamsToRestore) {
      this._initialUrlRestoreSnapshot = {
        rawTermId: rawTermId ?? null,
        termsIds: [...termsIds],
        divisions: [...divisions],
        departments: [...departments],
        courses: [...courses],
        courseRefIds: [...courseRefIds],
        sections: [...sections],
      };
      this._deferEmptyFilterUrlStrip = true;
    } else {
      this._initialUrlRestoreSnapshot = null;
      this._deferEmptyFilterUrlStrip = false;
    }

    const shouldSkipInitialLoading = window.__skipInitialCourseLoading === true;
    if (hasURLParamsToRestore && !shouldSkipInitialLoading) {
      this.callIfExists(window.showLoadingState);
    }

    const scheduleAttempt = () =>
      setTimeout(() => this.attemptURLRestoration(), 300);

    // Do not restore URL-driven UI until campus/term lists exist (same timing as populateCampus).
    if (window.__cmrpCampusTermFetchApplied === true) {
      scheduleAttempt();
    } else {
      document.addEventListener('cmrp:campusTermDataReady', scheduleAttempt, {
        once: true,
      });
    }
  }

  // @ts-ignore
  updateSelectedFilters(newSelectedFilters) {
    this.selectedFilters = newSelectedFilters;
  }

  getCurrentURLParams() {
    return this.parseURLParameters(false);
  }

  // @ts-ignore
  setCallbacks(callbacks) {
    if (callbacks.addLabel) this.addLabelCallback = callbacks.addLabel;
    if (callbacks.refreshProducts)
      this.refreshProductsCallback = callbacks.refreshProducts;
  }

  // @ts-ignore
  updateStudentIdInURL(studentId) {
    const params = new URLSearchParams(window.location.search);
    

    const newUrl = params.toString()
      ? `${window.location.pathname}?${params}`
      : window.location.pathname;

    window.history.replaceState({}, '', newUrl);
  }

  clearURLState() {
    //this.clearURL();
    this.clearExistingFilters();
    this.urlParamsToRestore = null;
    this._initialUrlRestoreSnapshot = null;
    this._deferEmptyFilterUrlStrip = false;
    this._isUrlRestoreInProgress = false;
    this._preservedShopByFromUrl = '';
  }
}

// @ts-ignore
window.URLStateManager = URLStateManager;

// @ts-ignore
if (!window.CourseMatSystem) {
  // @ts-ignore
  window.CourseMatSystem = {};
}
// @ts-ignore
window.CourseMatSystem.URLStateManager = URLStateManager;
